<template>
<section class="assessmentSection page-monitoringOverview">
    <div class="bg-white-cover"></div>
    <div class="pageContent">
        <div class="pageCompleted">System review | Monitoring</div>
        <div class="pageTitle">The features you selected determined this monitoring plan</div>
        <div class="pageText">You can learn more about the features by selecting them.</div>
    </div>
    <MonitoringPlanCard :type="selectedPlan.type"
                        :selected="selectedPlan.selected"
                        :level="selectedPlan.level"
                        :features="selectedPlan.features || null"
                        :price="selectedPlan.price"
                        :description="selectedPlan.description"
                        v-if="selectedPlan" />
    <continue-button to="/install-contract" text="Next" :before="mixpanelTracking" />
</section>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import MonitoringPlanCard from '../components/MonitoringPlanCard.vue'
export default {
    components: {
        MonitoringPlanCard
    },
    computed: {
        ...mapState([]),
        ...mapGetters(['selectedPlan']),
    },
    methods: {
        ...mapActions(['updateSystem']),
        mixpanelTracking() {
            mixpanel.track('completedMonitoringIntro')
        }
    },
    async mounted() {
        await this.updateSystem()
        mixpanel.people.set({ "Monitoring Plan": this.$store.getters.selectedPlan.name })
    }
}
</script>

<style lang="css"></style>
